import { Box, SxProps, Theme, Typography } from "@mui/material";
import React from "react";

type Props = {
  backgroundColor: string,
  color: string,
  label: string,
  sxBox?: SxProps<Theme>,
  sxLabel?: SxProps<Theme>,
};

const Chip: React.FC<Props> = ({ backgroundColor, color, label, sxBox = {}, sxLabel = {} }) => {
  return (
    <Box
      sx={{
        padding: '5px 10px',
        background: backgroundColor,
        borderRadius: 100,
        overflow: 'hidden',
        justifyContent: 'flex-start',
        alignItems: 'center',
        display: 'inline-flex',
        ...sxBox
      }}
    >
      <Typography
        sx={{
          fontSize: 13,
          fontWeight: '400',
          letterSpacing: 0.16,
          color,
          ...sxLabel,
        }}
      >
        { label }
      </Typography>
    </Box>
  )
};

export default Chip;
